"use client";
import { j as p } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as m from "react";
import { forwardRef as y } from "react";
import { t as E } from "./tv.config-BuYIgndg.mjs";
import { m as N, c as v, u as U } from "./useRenderElement-B8V3_e8R.mjs";
import { u as k } from "./useButton-CQeWQM5o.mjs";
import { u as w } from "./MenuRootContext-BxTmYndK.mjs";
import { u as B } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as C } from "./useCompositeListItem-Dxy1vBYe.mjs";
import { u as P } from "./FloatingTree-vWe5pGqE.mjs";
import { S as j } from "./Separator-CDRYgzW5.mjs";
const T = {
  type: "regular-item"
};
function _(h) {
  const {
    closeOnClick: n,
    disabled: s = !1,
    highlighted: u,
    id: r,
    menuEvents: e,
    allowMouseUpTriggerRef: t,
    typingRef: i,
    nativeButton: l,
    itemMetadata: o
  } = h, d = m.useRef(null), {
    getButtonProps: f,
    buttonRef: R
  } = k({
    disabled: s,
    focusableWhenDisabled: !0,
    native: l
  }), g = m.useCallback((M) => N({
    id: r,
    role: "menuitem",
    tabIndex: u ? 0 : -1,
    onMouseEnter() {
      o.type === "submenu-trigger" && o.setActive();
    },
    onKeyUp: (a) => {
      a.key === " " && i.current && a.preventBaseUIHandler();
    },
    onClick: (a) => {
      n && e.emit("close", {
        domEvent: a,
        reason: "item-press"
      });
    },
    onMouseUp: () => {
      d.current && t.current && o.type === "regular-item" && d.current.click();
    }
  }, M, f), [r, u, f, i, n, e, t, o]), c = v(d, R);
  return m.useMemo(() => ({
    getItemProps: g,
    itemRef: c
  }), [g, c]);
}
const I = /* @__PURE__ */ m.memo(/* @__PURE__ */ m.forwardRef(function(n, s) {
  const {
    className: u,
    closeOnClick: r = !0,
    disabled: e = !1,
    highlighted: t,
    id: i,
    menuEvents: l,
    itemProps: o,
    render: d,
    allowMouseUpTriggerRef: f,
    typingRef: R,
    nativeButton: g,
    ...c
  } = n, {
    getItemProps: M,
    itemRef: a
  } = _({
    closeOnClick: r,
    disabled: e,
    highlighted: t,
    id: i,
    menuEvents: l,
    allowMouseUpTriggerRef: f,
    typingRef: R,
    nativeButton: g,
    itemMetadata: T
  }), x = m.useMemo(() => ({
    disabled: e,
    highlighted: t
  }), [e, t]);
  return U("div", n, {
    state: x,
    ref: [a, s],
    props: [o, c, M]
  });
}));
process.env.NODE_ENV !== "production" && (I.displayName = "InnerMenuItem");
const b = /* @__PURE__ */ m.forwardRef(function(n, s) {
  const {
    id: u,
    label: r,
    nativeButton: e = !1,
    ...t
  } = n, i = m.useRef(null), l = C({
    label: r
  }), o = v(s, l.ref, i), {
    itemProps: d,
    activeIndex: f,
    allowMouseUpTriggerRef: R,
    typingRef: g
  } = w(), c = B(u), M = l.index === f, {
    events: a
  } = P();
  return /* @__PURE__ */ p.jsx(I, {
    ...t,
    id: c,
    ref: o,
    highlighted: M,
    menuEvents: a,
    itemProps: d,
    allowMouseUpTriggerRef: R,
    typingRef: g,
    nativeButton: e
  });
});
process.env.NODE_ENV !== "production" && (b.displayName = "MenuItem");
const O = E({
  base: [
    "Menu__item",
    "cursor-pointer",
    "flex",
    "px-4",
    "py-3",
    "text-sm",
    "leading-4",
    "tracking-wide",
    "outline-none",
    "select-none",
    "data-[highlighted]:before:absolute",
    "data-[highlighted]:before:inset-x-1",
    "data-[highlighted]:before:inset-y-0",
    "data-[highlighted]:before:z-[-1]",
    "data-[highlighted]:before:rounded-md",
    "data-[highlighted]:before:bg-primary-light/20",
    "data-[highlighted]:text-black",
    "data-[highlighted]:font-display",
    "data-[highlighted]:relative",
    "data-[highlighted]:z-0"
  ],
  variants: {}
}), W = y((h, n) => {
  const {
    className: s,
    divider: u,
    children: r,
    component: e = "div",
    ...t
  } = h;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      b,
      {
        ref: n,
        ...t,
        render: (i) => /* @__PURE__ */ p.jsx(e, { ...i }),
        className: O({
          class: typeof s == "string" ? s : ""
        }),
        children: r
      }
    ),
    u && /* @__PURE__ */ p.jsx(j, { className: "mx-4 my-1.5 h-px bg-gray-200" })
  ] });
});
export {
  W as default
};
